import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { USE_ALT_TOKEN } from 'src/shared/constants/alt-token-http-context';

@Injectable({
  providedIn: 'root'
})
export class AltHttpClientService {
  constructor(private http: HttpClient) { }

  get<T>(url: string, options?: { [key: string]: any }) {
    const context = (options?.['context'] || new HttpContext())
      .set(USE_ALT_TOKEN, true);

    return this.http.get<T>(url, {
      observe: 'body',
      responseType: 'json',
      ...options,
      context
    });
  }

  post<T>(url: string, body: any, options?: { [key: string]: any }) {
    const context = (options?.['context'] || new HttpContext())
      .set(USE_ALT_TOKEN, true);

    return this.http.post<T>(url, body, {
      observe: 'body',
      ...options,
      context
    });
  }

  put<T>(url: string, body: any, options?: { [key: string]: any }) {
    const context = (options?.['context'] || new HttpContext())
      .set(USE_ALT_TOKEN, true);

    return this.http.put<T>(url, body, {
      observe: 'body',
      ...options,
      context
    });
  }

  patch<T>(url: string, body: any, options?: { [key: string]: any }) {
    const context = (options?.['context'] || new HttpContext())
      .set(USE_ALT_TOKEN, true);

    return this.http.patch<T>(url, body, {
      observe: 'body',
      ...options,
      context
    });
  }

  delete<T>(url: string, options?: { [key: string]: any }) {
    const context = (options?.['context'] || new HttpContext())
      .set(USE_ALT_TOKEN, true);

    return this.http.delete<T>(url, {
      observe: 'body',
      ...options,
      context
    });
  }
}
